import * as React from 'react';
import { Form } from 'semantic-ui-react';

import Panel from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel';

import { DineroInput } from 'src/componentes';
import { Datos as AlumnosDatos } from '../../S3Alumnos';
import IdentificacionContrato from './IdentificacionContrato';

export interface Props {
    readonly todosLosAlumnos: ReadonlyArray<AlumnosDatos['alumnoPrincipal']>;
    alCambiarMontos(abonoInicial: number, indiceAlumno: number): void;
}

const AbonoInicial = (props: Props) => {
    const { todosLosAlumnos, alCambiarMontos } = props;

    return (
        <Panel titulo='Abono inicial'>
            {todosLosAlumnos.map((alumno, index) => (
                <Form.Field key={index} width='8'>
                    <label>
                        <IdentificacionContrato alumno={alumno} numero={index + 1} />
                    </label>
                    <DineroInput
                        monto={alumno.abonoInicial}
                        alCambiarMonto={monto => {
                            alCambiarMontos(monto, index);
                        }}
                    />
                </Form.Field>
            ))}

            <Form.Field width='8'>
                <label>Total</label>
                <DineroInput
                    soloLectura
                    monto={todosLosAlumnos.reduce((acc, alu) => acc + alu.abonoInicial, 0)}
                />
            </Form.Field>
        </Panel>
    );
};

export default AbonoInicial;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/AbonoInicial.tsx